const T = (size) => {
    return `calc(100vw * (${size}/1300));`;
};

const M = (size) => {
    return `calc(100vw * (${size}/428))`;
};

const MMinus = (size) => {
    return `calc(100% - 100vw * (${size}/428))`;
};

const MPlus = (size) => {
    return `calc(100% + 100vw * (${size}/428))`;
};

export { T, M, MMinus, MPlus };
